import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["name", "document", "order"]

  connect() {
    this._timer = null
  }

  searchName() {
    this.clearFieldsExcept("name")
  }

  searchDocument() {
    this.clearFieldsExcept("document")
    this.submitDigits(this.documentTarget, 11)
  }

  searchOrder() {
    this.clearFieldsExcept("order")
    this.submitDigits(this.orderTarget, 1)
  }

  clear() {
    clearTimeout(this._timer)
    this.clearFieldsExcept(null)
    this.submitForm(this.hasNameTarget ? this.nameTarget.form : this.orderTarget?.form)
    this.nameTarget?.focus()
  }

  disconnect() {
    clearTimeout(this._timer)
  }

  clearFieldsExcept(keep) {
    if (keep !== "name" && this.hasNameTarget) this.nameTarget.value = ""
    if (keep !== "document" && this.hasDocumentTarget) this.documentTarget.value = ""
    if (keep !== "order" && this.hasOrderTarget) this.orderTarget.value = ""
  }

  submitDigits(input, immediateAt) {
    const form = input.form
    if (!form) return

    const digits = input.value.replace(/\D/g, "")
    clearTimeout(this._timer)

    if (digits.length === 0 || digits.length >= immediateAt) {
      form.requestSubmit()
      return
    }

    this._timer = setTimeout(() => form.requestSubmit(), 250)
  }

  submitForm(form) {
    form?.requestSubmit()
  }
}
